import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchT3Banner: null,
  fetchT3BannerStart: null,
  fetchT3BannerSuccess: ['t3BannerData'],
  fetchT3BannerFailure: null,

  fetchLatestT3: ['pageNumber'],
  fetchLatestT3Start: null,
  fetchLatestT3Success: ['latestT3'],
  fetchLatestT3Failure: null
});

export { Types, Creators };
